module.exports = __webpack_public_path__ + "img/img-activate.6d2f59ab.png";